
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.8 1.2H22V.4a.4.4 0 00-.8 0v.8h-2.4V.4a.4.4 0 00-.8 0v.8h-2.4V.4a.4.4 0 00-.8 0v.8h-2.4V.4a.4.4 0 00-.8 0v.8H9.2V.4a.4.4 0 10-.8 0v.8H6V.4a.4.4 0 10-.8 0v.8H2.8V.4a.4.4 0 00-.8 0v.8h-.8A1.2 1.2 0 000 2.4v20.4A1.2 1.2 0 001.2 24h21.6a1.2 1.2 0 001.2-1.2V2.4a1.2 1.2 0 00-1.2-1.2zm.4 21.6a.4.4 0 01-.4.4H1.2a.4.4 0 01-.4-.4V5.6H20a.4.4 0 100-.8H.8V2.4c0-.22.18-.4.4-.4h21.6c.22 0 .4.18.4.4v20.4z","fill":"#00003C"}}),_c('path',{staticClass:"active-show active-highlight",attrs:{"d":"M2.116 2.916A.4.4 0 002.4 3.6a.4.4 0 00.284-.684.419.419 0 00-.568 0zM5.316 2.916a.4.4 0 10.568 0 .42.42 0 00-.568 0zM8.516 2.916a.4.4 0 10.568 0 .42.42 0 00-.568 0zM11.716 2.916a.4.4 0 10.568 0 .42.42 0 00-.568 0zM14.916 2.916a.4.4 0 10.568 0 .42.42 0 00-.568 0zM18.116 2.916a.4.4 0 10.568 0 .42.42 0 00-.568 0zM21.316 2.916a.4.4 0 10.568 0 .42.42 0 00-.568 0z","fill":"red"}}),_c('path',{attrs:{"d":"M20.8 7.6H3.2a.8.8 0 00-.8.8v12a.8.8 0 00.8.8h17.6a.8.8 0 00.8-.8v-12a.8.8 0 00-.8-.8zM7.2 20.4h-4V18h4v2.4zm0-3.2h-4v-2.4h4v2.4zm0-3.2h-4v-2.4h4V14zm0-3.2h-4V8.4h4v2.4zm4.4 9.6H8V18h3.6v2.4zm0-3.2H8v-2.4h3.6v2.4zm0-3.2H8v-2.4h3.6V14zm0-3.2H8V8.4h3.6v2.4zm4.4 9.6h-3.6V18H16v2.4zm0-3.2h-3.6v-2.4H16v2.4zm0-3.2h-3.6v-2.4H16V14zm0-3.2h-3.6V8.4H16v2.4zm4.8 9.6h-4V18h4v2.4zm0-3.2h-4v-2.4h4v2.4zm0-3.2h-4v-2.4h4V14zm0-3.2h-4V8.4h4v2.4z","fill":"#00003C"}})])
          )
        }
      }
    